/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_LabelInputs */

const en_price_page_app_label = /** @type {(inputs: Price_Page_App_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app`)
};

const pl_price_page_app_label = /** @type {(inputs: Price_Page_App_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja`)
};

/**
* | output |
* | --- |
* | "The app" |
*
* @param {Price_Page_App_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_label = /** @type {((inputs?: Price_Page_App_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_label(inputs)
	return en_price_page_app_label(inputs)
});